import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { TableHeadRowWrapper, TableHeadWrapper } from './styled';
export const TableHeadRow = memo(function TableHeadRow({ children, className }) {
    return (_jsx(TableHeadWrapper, { className: className, children: _jsx(TableHeadRowWrapper, { children: children }) }));
});
